export default `
  mutation createCardType($workflowId: ID!, $input: CardTypeInput!) {
    createCardType(workflowId: $workflowId, input: $input) {
      id
      title
      description
      color {
        red
        green
        blue
        rgb
      }
      showInBacklog
      workflowId
      domainModelRole
      defaultType
      generateWithAI
      order
    }
  }
`
